import {
  GET_SEARCH_SUGGESTIONS_FAILURE,
  GET_SEARCH_SUGGESTIONS_SUCCESS,
  GET_SEARCH_SUGGESTIONS_REQUEST,
} from '../constants/constructor-autosuggestions';

const initialState = {
  searchSuggestions: {},
};

/**
 *
 * @param {*} state
 * @param {*} action
 * @returns {*}
 */
export function searchSuggestions(state = initialState, action) {
  switch (action.type) {
    case GET_SEARCH_SUGGESTIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
        failedRequest: false,
      };
    case GET_SEARCH_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        searchSuggestions: action.payload.searchTerm,
        isFetching: false,
        failedRequest: false,
      };
    case GET_SEARCH_SUGGESTIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        failedRequest: true,
      };
    default:
      return state;
  }
}
